import { render, staticRenderFns } from "./AdminPresentersCard.vue?vue&type=template&id=4d88eab8"
import script from "./AdminPresentersCard.vue?vue&type=script&lang=js"
export * from "./AdminPresentersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports